module.exports = __webpack_public_path__ + "static/media/back-to-the-future-laces.7eb86267.md";